import {
  Input,
  Form,
  FormInstance
} from 'antd';
import { useContext, useEffect, useState } from 'react';
import { ContextApp } from '../../contexts/ContextApp';
import { IDecisionItem, IExtraInformation } from '../../interfaces/DecisionItems';
import GraphqlService from '../../services/graphql/GraphqlService';
import { ExportableColumn } from '../../shared/Exporter';
import { IDecisionItemConfiguration } from '../../interfaces/IDecisionItemConfiguration';
import { TParameter } from '../../i18n/i18n.model';
export function useDynamicDecisionItemColumns<T extends IDecisionItem >
 (props:{
    selectedExtraInformation?: IExtraInformation[];
    setSelectedExtraInformation: React.Dispatch<
        React.SetStateAction<IExtraInformation[] | undefined>>;
    formRef: React.MutableRefObject<FormInstance<any> | undefined>;
}) {

  const { selectedExtraInformation, formRef } = props;

  const { Query, customRequest } = GraphqlService();
  const { selectedTenantId, t } = useContext(ContextApp);

  const NO_RENDER = {
      product_code: 'product_code',
      cost_center: 'cost_center',
  }

  const dynamicConfigurations = async () => {

    const configurations: IDecisionItemConfiguration[] = await customRequest({
      query: Query.getDecisionItemConfigurations,
      variables: {
          filter: {
              tenant_id: selectedTenantId,
              visible: true,
          }
      }
    });
    return !configurations
    ? []
    : configurations.filter(c => // Para evitar repetir campos estáticos
        c.field_name !== NO_RENDER.product_code &&
        c.field_name !== NO_RENDER.cost_center 
      ); 

  }

  const [dynamicColumns, setDynamicColumns] = useState<ExportableColumn<T>[]>([]);
  useEffect(() => {

  const loadColumns = async () => {

    const configurations = await dynamicConfigurations();

    const columns: ExportableColumn<T>[] = [];


    for (let configuration of configurations) {

       if (selectedExtraInformation && selectedExtraInformation.length > 0 && selectedExtraInformation[0].extra_information){

        formRef.current?.setFieldValue(
            configuration.field_name,
            selectedExtraInformation[0].extra_information[configuration.field_name],
        )
       }
       else {
        formRef.current?.setFieldValue(configuration.field_name, null)
       }
        
        columns.push({
            export: false,
            sorter: false,
            dataIndex: configuration.field_name,
            title: t(configuration.translation_key as TParameter<string>).toString(),
            renderFormItem: () => (
              <>
                  <Form.Item name={configuration.field_name}>
                      <Input placeholder={t('message.placeholder.enterExtraInformation')}/>
                  </Form.Item>
              </>
            ),
            formItemProps: {
              rules: [
                  {
                      required: configuration.required,
                      message: t('error.abm.extraItemRequired')
                  }
              ]
            },
            align: 'left',
            hideInTable: true,
            hideInSearch: true,
            hideInForm: !configuration.visible,
        });
    }

    setDynamicColumns(columns);
  };

  loadColumns();
  }, [selectedExtraInformation]);

  return {
      dynamicColumns,
  };

}